export const getClampStyles = (lines: number = 1) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: String(lines),
  WebkitBoxOrient: 'vertical',
});
